import { DiscountRules } from '@ca/common/types'
import { useMemo } from 'react'

export const useUniqPromoCodes = (codes?: DiscountRules.PromotionItem[]) => {
  console.log('codes', codes)
  return useMemo(() => {
    const groups = new Set<string>()

    if (!codes) {
      return []
    }

    return codes.filter((code) => {
      if (groups.has(code.group ?? 'empty')) {
        return false
      }

      groups.add(code.group ?? 'empty')

      return true
    })
  }, [codes])
}
